module.exports = __webpack_public_path__ + "img/cancel-hen.6d3c05c8.png";